import { render, staticRenderFns } from "./icon_mdi_delete_off.vue?vue&type=template&id=6a8a6dbe"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports